export const DEFAULT_TIME_PERIOD_IN_YEARS = 5;
export const DEFAULT_DISCOUNT_RATE_PERCENTAGE = 10;
export const DEFAULT_SHARES_PERCENTAGE_FLOOR = 0.07;
export const DEFAULT_SHARES_PERCENTAGE_CEILING = 0.3;
